import { LibConfig } from "../../init";
export const getSportRequest = () => {
    return {
        eventState: LibConfig.eventState
    };
};
//# sourceMappingURL=getSportRequest.js.map